import type { IconDefinition } from "@outschool/icons";
import {
  faCrownRegular,
  faElephant,
  faFire,
  faOctopus,
  faPawClaws,
  faRobot,
  faRocket,
  faUnicorn,
} from "@outschool/icons";

import eagleIcon from "./avatar-animals/eagle.svg";
import monsterIcon from "./avatar-animals/monster.svg";
import sharkIcon from "./avatar-animals/shark.svg";
import tigerIcon from "./avatar-animals/tiger.svg";
import wolfIcon from "./avatar-animals/wolf.svg";

export const CREATURE_TYPES: ReadonlyArray<{
  value: string;
  label: string;
  icon: IconDefinition | string;
}> = [
  { value: "monster", label: "Monster", icon: monsterIcon },
  { value: "robot", label: "Robot", icon: faRobot },
  { value: "alien", label: "Alien", icon: faRocket },
  { value: "lion", label: "Lion", icon: faCrownRegular },
  { value: "eagle", label: "Eagle", icon: eagleIcon },
  { value: "shark", label: "Shark", icon: sharkIcon },
  { value: "elephant", label: "Elephant", icon: faElephant },
  { value: "tiger", label: "Tiger", icon: tigerIcon },
  { value: "bear", label: "Bear", icon: faPawClaws },
  { value: "wolf", label: "Wolf", icon: wolfIcon },
  { value: "octopus", label: "Octopus", icon: faOctopus },
  { value: "dragon", label: "Dragon", icon: faFire },
  { value: "unicorn", label: "Unicorn", icon: faUnicorn },
];

export const AVATAR_STYLES = [
  {
    value: "fantastical",
    label: "Fantastical",
    description: "Magical and whimsical with sparkles and fantasy elements",
  },
  {
    value: "simple",
    label: "Simple",
    description: "Stylized and clean with balanced realism",
  },
  {
    value: "cartoon",
    label: "Cartoon",
    description: "Bold, playful cartoon style",
  },
  {
    value: "line-art",
    label: "Line Art",
    description: "Outlined sketch style",
  },
  {
    value: "pixel",
    label: "Pixels",
    description: "Retro 16-bit pixel art style",
  },
  {
    value: "graphic",
    label: "Graphic",
    description: "Bold modern graphic design",
  },
  {
    value: "anime",
    label: "Anime",
    description: "Japanese manga/anime style",
  },
  {
    value: "surrealist",
    label: "Surrealist",
    description: "Dream-like fantastical imagery",
  },
] as const;

export const OUTDOOR_BACKGROUNDS = [
  "forest",
  "space",
  "playground",
  "beach",
  "mountains",
  "city",
  "underwater",
  "garden",
  "cave",
  "jungle",
  "snow",
  "savanna",
] as const;

export const INDOOR_BACKGROUNDS = [
  "none",
  "classroom",
  "lab",
  "library",
  "art-studio",
  "museum",
] as const;
